import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypess } from "../api/api";
import { Bar } from "react-chartjs-2";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
Chart.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function BarChart() {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);

const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypess("TradesVolume", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response);
      });
  }, []);

  return (
    <div className="card w-100">
      <div className="card-header">
        <h5 className="card-title">Monthly Trade Volumes</h5>
      </div>
      <div className="card-body d-flex w-100">
        <div className="align-self-center chart chart-lg">
          <div className="chartjs-size-monitor h-100">
            <div className="chartjs-size-monitor-shrink h-100">
              <div>
                <Bar
                  data={{
                    labels:
                      sectorAllocation &&
                      sectorAllocation.map((e: any) => {
                        return e.month;
                      }),
                    datasets: [
                      {
                        label: "Buy Transactions",
                        data:
                          sectorAllocation &&
                          sectorAllocation.map((e: any) => {
                            return e.numOfBuyTransactions;
                          }),
                        backgroundColor: ["rgb(124,181,236)"],
                        barThickness: 6,
                        maxBarThickness: 8,
                      },
                      {
                        label: "Sell Transactions",
                        data:
                          sectorAllocation &&
                          sectorAllocation.map((e: any) => {
                            return e.numOfSellTransactions;
                          }),
                        backgroundColor: ["rgb(67,67,72)"],
                        barThickness: 6,
                        maxBarThickness: 8,
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    aspectRatio: 1, // this would be a 1:1 aspect ratio
                    maintainAspectRatio: true,
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    scales: {
                      x: {
                        grid: {
                          display: false,
                        },
                      },
                      y: {
                        grid: {
                          display: false,
                        },
                        stacked: false,
                        ticks: {
                          stepSize: 50,
                        },
                      },

                      //   xAxes: [{
                      //     barThickness: 6,  // number (pixels) or 'flex'
                      //     maxBarThickness: 8 // number (pixels)
                      // }]
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { BarChart };
